import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabase';
import { financialService } from '../services/financialService';

export const useRealtimeFinancials = () => {
  const [revenueTrends, setRevenueTrends] = useState([]);
  const [outstandingInvoices, setOutstandingInvoices] = useState([]);
  const [paymentRate, setPaymentRate] = useState(0);
  const [avgCollectionTime, setAvgCollectionTime] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isLive, setIsLive] = useState(false);
  const [lastUpdate, setLastUpdate] = useState(null);

  const fetchFinancialData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const metrics = await financialService?.getAllFinancialMetrics();

      setRevenueTrends(metrics?.revenueTrends || []);
      setOutstandingInvoices(metrics?.outstandingInvoices || []);
      setPaymentRate(metrics?.paymentRate || 0);
      setAvgCollectionTime(metrics?.avgCollectionTime || 0);
      setLastUpdate(new Date());
    } catch (err) {
      console.error('Error fetching financial data:', err);
      setError(err?.message || 'Error al cargar datos financieros');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchFinancialData();

    // Subscribe to invoice changes
    const invoiceChannel = supabase
      ?.channel('financial_invoice_changes')
      ?.on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'invoices'
        },
        (payload) => {
          console.log('Invoice change detected:', payload);
          setIsLive(true);
          fetchFinancialData();
          
          setTimeout(() => setIsLive(false), 2000);
        }
      )
      ?.subscribe();

    // Subscribe to work order changes (for revenue trends)
    const workOrderChannel = supabase
      ?.channel('financial_work_order_changes')
      ?.on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'work_orders',
          filter: 'estado_ot=eq.entregado'
        },
        (payload) => {
          console.log('Work order delivered:', payload);
          setIsLive(true);
          fetchFinancialData();
          
          setTimeout(() => setIsLive(false), 2000);
        }
      )
      ?.subscribe();

    return () => {
      supabase?.removeChannel(invoiceChannel);
      supabase?.removeChannel(workOrderChannel);
    };
  }, [fetchFinancialData]);

  return {
    revenueTrends,
    outstandingInvoices,
    paymentRate,
    avgCollectionTime,
    loading,
    error,
    isLive,
    lastUpdate,
    refetch: fetchFinancialData
  };
};